import { Icon } from "assets/icons";
import { setModalCloseAtom } from "atoms/modalAtom/modalAtom";
import classNames from "classnames";
import { useSetAtom } from "jotai";
import { PropsWithChildren } from "react";
import { DivProps } from "types/html";

import styles from "./styles.module.scss";

export const DialogContent = ({
  className,
  children,
  setAtomClose = setModalCloseAtom,
  ...props
}: PropsWithChildren<DivProps & { setAtomClose?: any }>): JSX.Element => {
  const closeModal = useSetAtom(setAtomClose);

  return (
    <div
      {...props}
      className={classNames(
        styles.modalContent,
        "flex items-center flex-col",
        className
      )}
    >
      <Icon
        type="close"
        className="absolute right-4 top-4 cursor-pointer"
        onClick={closeModal}
      />
      {children}
    </div>
  );
};
